import { render, staticRenderFns } from "./createFaq.vue?vue&type=template&id=aed86d78&"
import script from "./createFaq.vue?vue&type=script&lang=js&"
export * from "./createFaq.vue?vue&type=script&lang=js&"
import style0 from "./createFaq.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports